<template>
  <!-- 文件包 -->
  <div
    class="id_10"
    v-loading="loading"
    element-loading-text="正在下载，可能需要几分钟，请耐心等待…"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <!-- 批量下载 -->
    <div class="download" v-show="list.length>1">
      <span class="cursor" @click="allDownload">批量打包下载</span>
    </div>

    <!-- 这个文件显示大盒子 -->
    <div class="file_box">
      <!-- 文件列表 -->
      <div class="item" v-for="(item, index) in list" :key="item.fileId || index">
        <div class="item_box cursor" @click="download(item)">
          <div class="img">
            <img :src="$utils.getFileIcon(item.fileName)">
          </div>
          <!-- <el-tooltip
            :content="item.fileName"
            placement="top"
            :open-delay="300"
            effect="dark"> -->
            <p :title="item.fileName" class="file-name" :data-file-url="item.fileUrl || ''">{{ truncateFileName(item.fileName) }}</p>
          <!-- </el-tooltip> -->
          <div class="item_actions">
            <svg t="1785910833346" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2867" width="200" height="200"><path d="M911.36 573.0816a40.96 40.96 0 0 1 40.6528 35.84l0.3072 5.12v245.3504a92.16 92.16 0 0 1-84.5824 91.8528l-7.5776 0.3072h-716.8a92.16 92.16 0 0 1-91.8528-84.5824L51.2 859.392v-245.3504a40.96 40.96 0 0 1 81.6128-5.12l0.3072 5.12v245.3504a10.24 10.24 0 0 0 7.5264 9.8816l2.7136 0.3584h716.8a10.24 10.24 0 0 0 9.8816-7.5264l0.3584-2.7136v-245.3504a40.96 40.96 0 0 1 40.96-40.96zM501.76 51.2a40.96 40.96 0 0 1 40.6528 35.84l0.3072 5.12-0.0512 490.3936 199.8336-153.1392a40.96 40.96 0 0 1 54.016 61.2864l-4.1984 3.6864-265.1136 203.3664a40.96 40.96 0 0 1-44.8512 3.2768l-5.12-3.3792-263.168-203.3152a40.96 40.96 0 0 1 45.4656-67.9424l4.608 3.072L460.8 581.3248 460.8 92.16a40.96 40.96 0 0 1 40.96-40.96z" fill="#4a4a51" p-id="2868"></path></svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import JSZip from 'jszip'
import FileSaver from 'file-saver'

export default {
  props: {
    data: Object
  },
  name: 'id_10',
  data () {
    return {
      loading: false,
      // list: [{fileName: '193f194be66e60e00e3949e5451b2cf4.zip', fileUrl: 'http://133.13.13.125/bloom_web/123321.zip'}, {fileName: '获奖名单格式.xlsx', fileUrl: 'http://133.13.13.125/bloom_web/321123.xlsx'}]
      list: []
    }
  },
  methods: {
    /**
     * 截断文件名
     * @param {String} fileName - 原始文件名
     * @param {Number} maxLength - 截断后的最大长度（包含省略号）
     * @returns {String} 截断后的文件名
     */
    truncateFileName (fileName, maxLength = 25) {
      if (!fileName) return ''
      
      if (fileName.length <= maxLength) {
        return fileName
      }
      
      const lastDotIndex = fileName.lastIndexOf('.')
      const extension = lastDotIndex !== -1 ? fileName.substring(lastDotIndex) : ''
      const baseName = lastDotIndex !== -1 ? fileName.substring(0, lastDotIndex) : fileName
      
      const truncatedLength = maxLength - extension.length - 8
      
      if (truncatedLength <= 0) {
        return '...' + extension
      }
      
      const truncatedBase = baseName.substring(0, 5)
      const last5Chars = baseName.substring(baseName.length - 5, baseName.length)
      
      return truncatedBase + '...' + last5Chars + extension
    },
    // 打包下载
    allDownload () {
      const self = this
      // 组件可能通过 new ComponentConstructor() 动态实例化，不在 router 组件树内，
      // this.$route 和 this.$root.$route 均为 undefined，需从 URL 直接解析
      const taskTitle = this.getRouteQuery('taskTitle') || this.getRouteQuery('name') || ''
      const fileName = taskTitle ? taskTitle + '-打包文件.zip' : 'bloom课程文件.zip'
      this.loading = true
      const abc = async () => {
        const data = self.list
        const zip = new JSZip()
        const cache = {}
        const promises = []
        await data.forEach((item, key) => {
          const promise = self.getFile(item.fileUrl).then(dta => { // 下载文件, 并存成ArrayBuffer对象
            zip.file(item.fileName, dta.data, {binary: true}) // 逐个添加文件
            cache[item.fileName] = dta
          })
          promises.push(promise)
        })
        Promise.all(promises).then(() => {
          zip.generateAsync({type: 'blob'}).then(content => {              // 生成二进制流
            FileSaver.saveAs(content, fileName)                  // 利用file-saver保存文件
            self.loading = false
          }).catch(err => {
            console.log(err)
            self.loading = false
            self.$message.error(self.$t('flowCertificate11'))
          })
        })
      }
      abc()
    },
    /**
     * 获取路由查询参数
     * @description 组件可能通过 new ComponentConstructor() 动态实例化，
     *              此时 this.$route 和 this.$root.$route 均为 undefined。
     *              此方法优先从 $route 获取，失败时从 URL hash 直接解析。
     * @param {String} key - 查询参数名
     * @returns {String|null} 参数值
     */
    getRouteQuery (key) {
      // 优先从 $route 获取（正常组件树内）
      if (this.$route && this.$route.query && this.$route.query[key]) {
        return this.$route.query[key]
      }
      // 动态实例化场景：从 hash URL 解析查询参数
      // URL 格式: http://xxx/#/path?taskTitle=xxx&seasonId=yyy
      const hash = window.location.hash || ''
      const queryIndex = hash.indexOf('?')
      if (queryIndex === -1) return null
      const queryString = hash.substring(queryIndex + 1)
      const params = new URLSearchParams(queryString)
      return this.truncateFileName(params.get(key), 15)
    },
    // 下载文件
    getFile (url) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url,
          responseType: 'arraybuffer'
        }).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error.toString())
        })
      })
    },
    // 单个下载
    download (data) {
      this.getFile(data.fileUrl).then(dta => {
        FileSaver.saveAs(new Blob([dta.data], {type: 'application/octet-stream'}), data.fileName)
      })
    },
    // 初始化
    init () {
      if (this.data.list) {
        let arr = JSON.parse(this.data.list) || []
        this.list = arr
      }
    }
  },
  created () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
/*里面的代码可以根据自己需求去进行更改*/
/* 设置滚动条的样式 */
::-webkit-scrollbar {
  height: 6px;
  display: inline-block !important;
}
  /* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  height: 6px;
  border-radius: 10px;
  background: #D4D4D4;
  -webkit-box-shadow: inset006pxrgba(0,0,0,0.5);
}
.id_10{
  padding-top: 24px;
  border-radius: 4px;
  word-wrap:break-word;
  overflow: hidden;
  overflow-x: scroll;
  .download{
    span{
      font-size: 14px;
      color: #2b6fff;
      text-decoration: underline;
    }
  }
  .file_box{
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 16px;
    
    .item{
      width: calc(50% - 8px);
      min-width: 270px;
      
      .item_box{
        display: flex;
        align-items: center;
        position: relative;
        z-index: 0;
        background: #ffffff;
        border: 1px solid #E4E7ED;
        border-radius: 8px;
        padding: 12px;
        transition: all 0.3s ease;
        cursor: pointer;
        
        .img{
          font-size: 0;
          width: 36px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          
          img{
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        
        .file-name{
          text-align: left;
          padding-left: 12px;
          margin: 0;
          font-size: 13px;
          color: #606266;
          line-height: 1.4;
          word-break: break-all;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          max-height: 2.8em;
          transition: color 0.3s ease;
        }
        
        .item_actions{
          display: flex;
          gap: 4px;
          .icon{
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 12px;
            width: 18px;
            height: 18px;
            &:hover{
              color: #409EFF;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/course/public/id_10.vue